import moment from "moment";
import { groupBy, flatten } from "lodash";

export function FilterByDropdownData(
  filteredbyDateData,
  selectedOptions,
  activeNav,
  top25USTopoSelected,
  top25LPCSelected,
  top25MRLCSelected
) {
  const selectedTheme = selectedOptions.theme;
  const reportType = selectedOptions.type;
  const selectedResponseCode = selectedOptions.responseCode.substring(0, 3);
  const selectedFileType = selectedOptions.fileType;
  const downloadLogSource = selectedOptions.source;
  const useInterfaceAlias = selectedOptions.useInterfaceAlias;
  const useDatasetAlias = selectedOptions.useDatasetAlias;
  const useThemeAlias = selectedOptions.useThemeAlias;
  const subKeyFieldName = {
    1: "Dataset",
    2: "Interface",
    3: "Interface",
  };
  let selectedInterface = selectedOptions.interface;
  let selectedDataset = selectedOptions.dataset;
  let groupedData = [];
  let filteredDataArray = [];

  // Filter by interface if it's basemaps or services, filter by dataset if it's downloads
  if (activeNav === 2 || activeNav === 3) {
    selectedDataset = ""; // why? TODO
    if (selectedInterface !== "All") {
      filteredbyDateData = filteredbyDateData.filter((item) => {
        if (useInterfaceAlias === "True") {
          return item["interface_alias"] === selectedInterface;
        } else {
          return item["interface"] === selectedInterface;
        }
      });
    }
  }
  // downloads
  if (activeNav === 1) {
    // when log source is selected --> themes dropdown is updated --> dataset dropdown is updated
    //   --> selectedOption theme = 'All', selectedOption dataset = 'All'
    // Downloads - Datasets are dependent on Themes
    selectedInterface = "";
    if (downloadLogSource !== "All") {
      filteredbyDateData = filteredbyDateData.filter(
        (item) => item["source"] === downloadLogSource
      );
    }
    //filter datasets
    if (selectedDataset !== "All") {
      filteredbyDateData = filteredbyDateData.filter((item) => {
        if (useDatasetAlias === "True") {
          return item["dataset_alias"] === selectedDataset;
        } else {
          return item["dataset"] === selectedDataset;
        }
      });
    }
  }

  //filter status code for downloads and viewer
  if (activeNav === 1 || activeNav === 4 || activeNav === 5) {
    if (selectedResponseCode !== "All") {
      filteredbyDateData = filteredbyDateData.filter(
        (item) => item["statusCode"] === selectedResponseCode.toString()
      );
    }
  }

  //filter filetype for downloads
  if (activeNav === 1) {
    if (selectedFileType !== "All") {
      filteredbyDateData = filteredbyDateData.filter(
        (item) =>
          item["fileType"].toString().toUpperCase().replaceAll(".", "") ===
          selectedFileType.toString().toUpperCase().replaceAll(".", "")
      );
    }
  }

  //always filter theme
  if (selectedTheme !== "All") {
    // Select items only for the selected theme
    filteredbyDateData = filteredbyDateData.filter((item) => {
      if (useThemeAlias === "True") {
        return item["theme_alias"] === selectedTheme;
      } else {
        return item["theme"] === selectedTheme;
      }
    });
  }

  switch (reportType) {
    case "Summary by Theme":
      if (selectedTheme === "All") {
        // OPTION #1) theme=All & subkey=All ---- no need to care about subkeys.
        // OPTION #2) theme=All & subkey=Not All --- Dataset/Interface have already been filtered by the selected subkey.
        // Option #2 is possible only for basemaps and service (disabled for downloads by dropdown config)

        if (useThemeAlias === "True") {
          groupedData = groupBy(filteredbyDateData, "theme_alias");
        } else {
          groupedData = groupBy(filteredbyDateData, "theme");
        }

        filteredDataArray = Object.keys(groupedData).map((key) => {
          const dataObj = {};
          dataObj.Description = key;
          dataObj.Size = groupedData[key].reduce(
            (prevVal, elem) => prevVal + parseInt(elem.size, 10),
            0
          );
          dataObj.Hits = groupedData[key].reduce(
            (prevVal, elem) => prevVal + parseInt(elem.hits, 10),
            0
          );
          dataObj.Visitors = groupedData[key].reduce(
            (prevVal, elem) => prevVal + parseInt(elem.visitors, 10),
            0
          );
          dataObj.Views = groupedData[key].reduce(
            (prevVal, elem) => prevVal + parseInt(elem.pageViews, 10),
            0
          );

          if (selectedInterface !== "") {
            dataObj.Interface = selectedInterface;
          }
          if (selectedDataset !== "") {
            dataObj.Dataset = selectedDataset;
          }
          if (selectedFileType !== "") {
            dataObj.Type = selectedFileType;
          }
          if (selectedResponseCode !== "") {
            dataObj.Response = selectedResponseCode;
          }
          if (activeNav === 1 && downloadLogSource !== "") {
            dataObj.Source = downloadLogSource;
          }
          return dataObj;
        });
      } else {
        //TODO: subKeys was globally referenced but now it's only being used here
        //I think we can do if(selectedDataset) and if(selectedInterface) again
        const subKeys = {
          1: "dataset",
          2: "interface",
          3: "interface",
        };
        // This is Option3: theme is selected
        // Dataset/Interface have already been filtered by the selected subkey at the beginning if necessary.
        if (subKeys[activeNav] === "dataset") {
          if (useDatasetAlias === "True") {
            groupedData = groupBy(
              filteredbyDateData,
              subKeys[activeNav] + "_alias"
            );
          } else {
            groupedData = groupBy(filteredbyDateData, subKeys[activeNav]);
          }
          if (selectedDataset !== "All") {
            groupedData = groupBy(filteredbyDateData, "fileType");
          }
        } else if (useInterfaceAlias === "True") {
          groupedData = groupBy(
            filteredbyDateData,
            subKeys[activeNav] + "_alias"
          );
        } else {
          groupedData = groupBy(filteredbyDateData, subKeys[activeNav]);
        }

        filteredDataArray = Object.keys(groupedData).map((key) => {
          const dataObj = {};
          dataObj.Description = selectedTheme;
          if (selectedDataset === "" || selectedDataset === "All") {
            dataObj[subKeyFieldName[activeNav]] = key;
          } else {
            dataObj[subKeyFieldName[activeNav]] = selectedDataset;
          }

          dataObj.Size = groupedData[key].reduce(
            (prevVal, elem) => prevVal + parseInt(elem.size, 10),
            0
          );
          dataObj.Hits = groupedData[key].reduce(
            (prevVal, elem) => prevVal + parseInt(elem.hits, 10),
            0
          );
          dataObj.Visitors = groupedData[key].reduce(
            (prevVal, elem) => prevVal + parseInt(elem.visitors, 10),
            0
          );
          dataObj.Views = groupedData[key].reduce(
            (prevVal, elem) => prevVal + parseInt(elem.pageViews, 10),
            0
          );
          if (downloadLogSource !== "") {
            dataObj.Source = downloadLogSource;
          }
          if (selectedFileType !== "") {
            dataObj.Type = selectedFileType;
          }
          if (selectedDataset !== "" && selectedDataset !== "All") {
            dataObj.Type = key;
          }
          if (selectedResponseCode !== "") {
            dataObj.Response = selectedResponseCode;
          }
          return dataObj;
        });
      }
      break;

    case "Daily":
      // Downloads - if Log source is selected, it was filtered at Line#71.
      groupedData = groupBy(filteredbyDateData, "date");
      filteredDataArray = Object.keys(groupedData).map((key) => {
        const dataObj = {};
        dataObj.Description = moment(key, "YYYYMMDD").format("YYYY-MM-DD");
        dataObj.Theme = selectedTheme;
        dataObj.Size = groupedData[key].reduce(
          (prevVal, elem) => prevVal + parseInt(elem.size, 10),
          0
        );
        dataObj.Hits = groupedData[key].reduce(
          (prevVal, elem) => prevVal + parseInt(elem.hits, 10),
          0
        );
        dataObj.Visitors = groupedData[key].reduce(
          (prevVal, elem) => prevVal + parseInt(elem.visitors, 10),
          0
        );
        dataObj.Views = groupedData[key].reduce(
          (prevVal, elem) => prevVal + parseInt(elem.pageViews, 10),
          0
        );

        if (selectedInterface !== "") dataObj.Interface = selectedInterface;
        if (selectedDataset !== "") dataObj.Dataset = selectedDataset;
        if (selectedFileType !== "") dataObj.Type = selectedFileType;
        if (selectedResponseCode !== "") {
          dataObj.Response = selectedResponseCode;
        }
        if (downloadLogSource !== "") dataObj.Source = downloadLogSource;

        return dataObj;
      });
      break;

    case "Monthly": {
      const inputDateFormat = "YYYYMMDD";
      filteredbyDateData.forEach((item) => {
        item.MonthYear = moment(item["date"], inputDateFormat).format(
          "YYYY-MM"
        );
      });
      groupedData = groupBy(filteredbyDateData, "MonthYear");

      filteredDataArray = Object.keys(groupedData).map((key) => {
        let numberOfDays = parseInt(moment(key, "YYYY-MM").daysInMonth(), 10);
        const isThisMonth = moment(key, "YYYY-MM").month() === moment().month();
        if (isThisMonth === true) {
          numberOfDays = Math.max.apply(
            null,
            groupedData[key].map((item) => {
              return moment(item.date, inputDateFormat).date();
            })
          );
        }
        const dataObj = {};
        dataObj.Description = key;
        dataObj.Theme = selectedTheme;
        dataObj.Size = groupedData[key].reduce(
          (prevVal, elem) => prevVal + parseInt(elem.size, 10),
          0
        );
        dataObj["Average Daily Size"] = dataObj.Size / numberOfDays;

        dataObj.Hits = groupedData[key].reduce(
          (prevVal, elem) => prevVal + parseInt(elem.hits, 10),
          0
        );

        dataObj["Average Daily Hits"] = dataObj.Hits / numberOfDays;

        dataObj.Visitors = groupedData[key].reduce(
          (prevVal, elem) => prevVal + parseInt(elem.visitors, 10),
          0
        );
        dataObj.Views = groupedData[key].reduce(
          (prevVal, elem) => prevVal + parseInt(elem.pageViews, 10),
          0
        );
        dataObj.NumDays = parseInt(numberOfDays, 10);

        if (selectedInterface !== "") dataObj.Interface = selectedInterface;
        if (selectedDataset !== "") dataObj.Dataset = selectedDataset;
        if (selectedFileType !== "") dataObj.Type = selectedFileType;
        if (selectedResponseCode !== "") {
          dataObj.Response = selectedResponseCode;
        }
        if (downloadLogSource !== "") dataObj.Source = downloadLogSource;

        return dataObj;
      });
      break;
    }

    case "Summary": {
      const dataObj = {};
      dataObj.Description = selectedTheme;
      dataObj.Size = filteredbyDateData.reduce(
        (prevVal, elem) => prevVal + parseInt(elem.size, 10),
        0
      );
      dataObj.Hits = filteredbyDateData.reduce(
        (prevVal, elem) => prevVal + parseInt(elem.hits, 10),
        0
      );
      dataObj.Visitors = filteredbyDateData.reduce(
        (prevVal, elem) => prevVal + parseInt(elem.visitors, 10),
        0
      );
      dataObj.Views = filteredbyDateData.reduce(
        (prevVal, elem) => prevVal + parseInt(elem.pageViews, 10),
        0
      );

      if (selectedInterface !== "") dataObj.Interface = selectedInterface;
      if (selectedDataset !== "") dataObj.Dataset = selectedDataset;
      if (selectedFileType !== "") dataObj.Type = selectedFileType;
      if (selectedResponseCode !== "") {
        dataObj.Response = selectedResponseCode;
      }
      if (downloadLogSource !== "") dataObj.Source = downloadLogSource;

      if (activeNav === 5) {
        dataObj.Description = "MRLC";
      }

      filteredDataArray.push(dataObj);
      break;
    }

    default:
      return;
  }

  const processGroupedData = (groupedData, titleKey) => {
    const summedArray = Object.keys(groupedData).map((key) => {
      const dataObj = {};
      dataObj.Description = selectedTheme;
      dataObj.Dataset = selectedDataset;
      if (titleKey === "mapTitle") {
        dataObj.Title = key;
        dataObj.State = groupedData[key][0]["stateAbbr"];
      }
      if (titleKey === "fileName") {
        dataObj.Name = key;
      }
      dataObj.Size = groupedData[key].reduce(
        (prevVal, elem) => prevVal + parseInt(elem.size, 10),
        0
      );
      dataObj.Hits = groupedData[key].reduce(
        (prevVal, elem) => prevVal + parseInt(elem.hits, 10),
        0
      );

      if (selectedInterface !== "") {
        dataObj.Interface = selectedInterface;
      }
      if (selectedDataset !== "") {
        dataObj.Dataset = selectedDataset;
      }
      if (selectedFileType !== "") {
        dataObj.Type = selectedFileType;
      }
      if (selectedResponseCode !== "") {
        dataObj.Response = selectedResponseCode;
      }

      return dataObj;
    });

    const sortedArray = summedArray.sort((a, b) => b.Hits - a.Hits);

    return flatten(sortedArray).slice(0, 25);
  };

  if (top25USTopoSelected || top25MRLCSelected) {
    const groupedData = groupBy(filteredbyDateData, "mapTitle");
    filteredDataArray = processGroupedData(groupedData, "mapTitle");
  }

  if (top25LPCSelected) {
    const groupedData = groupBy(filteredbyDateData, "fileName");
    filteredDataArray = processGroupedData(groupedData, "fileName");
  }

  return filteredDataArray;
}
